import {Event} from 'main.core';
import {Modal} from 'asteq.modal';

export class ModalAjax extends Modal {
    constructor(params = {}) {
        super(params);

        this.contentEl = this.el.querySelector('[data-content]');
    }

    show(url, showParams) {
        if (!this.contentEl) {
            console.error('Не установлен элемент для загрузки контента');
            return;
        }



        BX.ajax({
            url: url,
            method: "get",
            dataType: "html",
            processData: false,
            onsuccess: this.onSuccessContentLoaded.bind(this, showParams),
            onfailure: () => console.error('Error!'),
        });
    }

    setContent(content) {
        const processed = BX.processHTML(content);
        this.emit('onSetContentBefore');
        this.contentEl.innerHTML = processed.HTML;

        const firstChild = this.contentEl.children
            && Array.from(this.contentEl.children)
                .filter((child) => child.id)[0];

        if (firstChild) {
            Event.EventEmitter.subscribeOnce('BX.Asteq.Modal:onContentReady' + firstChild.id, () => {
                const callbackId = 'callback' + firstChild.id;
                if (window[callbackId] && typeof window[callbackId] === 'function') {
                    window[callbackId]({
                        modal: this,
                    });
                    delete window[callbackId];
                }
            });
        }

        BX.ajax.processScripts(processed.SCRIPT);

        this.emit('onSetContentAfter');
    }

    onSuccessContentLoaded(showParams, response) {
        if (!this.contentEl) {
            console.error('Не установлен элемент для показа контента');
            return;
        }

        this.setContent(response);
        this.open(showParams);
    }
}